module.exports = __webpack_public_path__ + "static/images/cover_C15.1cd4543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C15.png
// module id = 6z/S
// module chunks = 8